import { render, staticRenderFns } from "./JobActivity.vue?vue&type=template&id=31944a78&"
import script from "./JobActivity.vue?vue&type=script&lang=js&"
export * from "./JobActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports